export default {
    bindings: {
        error: '<'
    },
    template: require('../views/store.payment.errors.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/store.payment.errors.component.js